const darken = (color, percentage) => {
  if (typeof color !== 'string') throw new Error('Color must be of type string');
  return `color-mix(in srgb, ${color}, black ${percentage}%)`;
};
const lighten = (color, percentage) => {
  if (typeof color !== 'string') throw new Error('Color must be of type string');
  return `color-mix(in srgb, ${color}, white ${percentage}%)`;
};
const translucify = (color, percentage) => {
  if (typeof color !== 'string') throw new Error('Color must be of type string');
  return `color-mix(in srgb, ${color} ${percentage}%, transparent)`;
};

export { darken, lighten, translucify };
//# sourceMappingURL=colors.js.map
